import ReactDOM from 'react-dom';

export default function innerText(element) {
  const container = document.createElement('div');
  ReactDOM.render(element, container);
  return container.textContent.trim();
}
